export default __webpack_public_path__ + "static/media/menu-icon-blue.cc1425c4.svg";